import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region ../icons/dist/react/minimal/speed.js
const SpeedIcon = (props, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "currentColor",
	"aria-hidden": "true",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: [
		/* @__PURE__ */ jsx("path", { d: "M9 18q-.213 0-.424-.012h.85Q9.214 18 9 18M9 2a8 8 0 0 1 8 8c0 1.975-.719 3.78-1.905 5.175a.75.75 0 0 1-1.204.018l-1.509-1.971a.75.75 0 0 1 .596-1.206h2.202a6.5 6.5 0 1 0-12.36 0h2.209a.75.75 0 0 1 .595 1.206l-1.507 1.971a.75.75 0 0 1-1.133.07l-.003.004A8 8 0 0 1 9 2" }),
		/* @__PURE__ */ jsx("rect", {
			width: 6,
			height: 1.5,
			x: 6,
			y: 14,
			fillOpacity: .5,
			rx: .75
		}),
		/* @__PURE__ */ jsx("path", { d: "M8.504 5.217c.077-.578.915-.578.992 0l.399 2.996A1.998 1.998 0 0 1 9 12a2 2 0 0 1-.896-3.787z" }),
		/* @__PURE__ */ jsxs("g", {
			fillOpacity: .5,
			children: [
				/* @__PURE__ */ jsx("circle", {
					cx: 4.75,
					cy: 9.75,
					r: .75
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: 13.25,
					cy: 9.75,
					r: .75
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: 6,
					cy: 6.75,
					r: .75
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: 12,
					cy: 6.75,
					r: .75
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SpeedIcon);
//#endregion
export { ForwardRef as default };

//# sourceMappingURL=speed.js.map